
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/active-campaign",
      function () {
        return require("private-next-pages/destinations/active-campaign.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/active-campaign"])
      });
    }
  